import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

/* Bold to match the price it shares a row with, but kept at the smaller body
   size so the row's height does not move. As elsewhere in this card, 700 is a
   literal because the theme has one body weight and no bold step. */
export const rating = css`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: var(${spacing.xxs});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  font-weight: 700;
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.default});
`;

/* "NEW" stands in for a rating a product does not have yet, so it takes the
   brand colour to read as a flag rather than as a score. */
export const isNew = css`
  color: var(${colors.content.brand});
`;

export const star = css`
  display: inline-flex;
  line-height: 0;
`;
